import UserRoleTransfer from './user-role-transfer.vue'
UserRoleTransfer.install = function (Vue) {
  Vue.component(UserRoleTransfer.name, UserRoleTransfer);
};
export default UserRoleTransfer



// WEBPACK FOOTER //
// ./src/omnis-business/user-role-transfer/index.js